import React from 'react';
import {parseTextWithLinksAndBold} from '../helpers/parse-text';

type Content = {
  title: string;
  paragraphs?: string[];
  list?: {
    title: string;
    items: string[];
  };
  summary?: string;
};

type DescriptionProps = {
  titleH1: string;
  titleH2?: string;
  description?: string;
  content?: Content[];
};

const Description = ({ titleH1, description, content }: DescriptionProps) => {

  return (
    <section className="freight-dictionary-landing__description">
      <div className="container">
        {content ? (
          <>
            {content.map(({title, paragraphs, list, summary}, idx) => {
              return (
                <React.Fragment key={idx}>
                  <h2 className="freight-dictionary-landing__description-title">
                      {title}
                  </h2>
                  <div>
                    {paragraphs && paragraphs.map((paragraph, idx) => (
                      <p key={idx}
                         className="freight-dictionary-landing__description-paragraph">{parseTextWithLinksAndBold(paragraph)}</p>
                    ))}
                  </div>
                  {list && (
                    <>
                      {list.title && <p className="freight-dictionary-landing__list-title">{parseTextWithLinksAndBold(list.title)}</p>}
                      <ul className="freight-dictionary-landing__list-benefits">
                        {list.items.map((item, idx) => (
                          <li className="freight-dictionary-landing__list-benefits-item" key={idx}>{parseTextWithLinksAndBold(item)}</li>
                        ))}
                      </ul>
                    </>
                  )}
                  {summary && <p key={idx}
                                 className="freight-dictionary-landing__description-paragraph">{parseTextWithLinksAndBold(summary)}</p>}
                </React.Fragment>
              )
            })}
          </>
        ) : (
          <>
            <h2 className="freight-dictionary-landing__description-title">
              <span className="freight-dictionary-landing__description-title-text">
                {titleH1} Meaning
              </span>
            </h2>
            <p className="freight-dictionary-landing__description-paragraph">{description}</p>
          </>
        )}
      </div>
    </section>
  );
};

export default Description;
